import { Button } from "@mui/material"
import { fileServerUrlParser } from "../../misc/utils"
import React from "react"
export const widgetFileDownloadButtonPrototype = [
    {
        key: "file",
        type: "ICONSELECT",
        label: "file",
        size: 6,
        options: {
            tag: "datei",
        },
    },
    {
        key: "action",
        type: "STRING",
        label: "Aktion",
        size: 3,
    },
]

export default function DownloadFileWidget({ value = "pdf" }) {
    const files = Object.values(value ?? [])

    if (files.length === 0) {
        return <div />
    }

    return (
        <div className="download-file">
            {files.map((file) => (
                <FileItem key={file.name} file={file} />
            ))}
        </div>
    )
}

function FileItem({ file }) {
    const handleDownload = () => {
        const parsedUrl = fileServerUrlParser(file.url)

        window.open(parsedUrl, "_blank")

        const link = document.createElement("a")
        link.href = parsedUrl
        link.setAttribute("download", file.name)
    }

    return (
        <div className="file-item">
            <span>{file.label}</span>
            <Button onClick={handleDownload}>Download</Button>
        </div>
    )

}
